/* eslint-disable no-useless-catch */
import axios, { AxiosRequestConfig } from 'axios';
import {
  requestCallerMiddleware,
  unauthorisedMiddlewareResponse,
  unauthorisedMiddlewareResponseError,
  requestIdMiddleware,
} from './apiMiddlewares';

axios.interceptors.response.use(
  unauthorisedMiddlewareResponse,
  unauthorisedMiddlewareResponseError
);
axios.interceptors.request.use(requestCallerMiddleware);
axios.interceptors.request.use(requestIdMiddleware);

export const callApi = async (config: AxiosRequestConfig) => {
  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    // console.log(error);
    throw error;
  }
};

export default axios;
